module.exports = __webpack_public_path__ + "static/spicy-coriander-a3feecc1d9195029c3f7973fbf155500.png";